import React from 'react';
import {Breadcrumb, Row, Col} from 'antd';
import UsersContainer from './UsersContainer';

const UsersView = () => {
    return (
        <div>
            <UsersContainer/>
        </div>);
}

export default UsersView
